import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import styles from './TabLabel.module.css';

type TabLabelProps = {
  label: string;
  count?: number;
  showCount?: boolean;
  active?: boolean;
  isLoading?: boolean;
};

export const TabLabel: React.FC<TabLabelProps> = ({ label, count, showCount, active = false, isLoading = false }) => {
  const getCountClassName = () => {
    if (isLoading) {
      return active ? styles.tabCountActiveLoading : styles.tabCountLoading;
    }
    return active ? styles.tabCountActive : styles.tabCount;
  };

  return (
    <div className={styles.tabLabel}>
      <span className={classNames(styles.textLabel, active && styles.textLabelActive)}>{label}</span>
      {showCount && (
        <span className={getCountClassName()}>
          {isLoading ? <LoadingOutlined className={styles.countSpinner} /> : count !== undefined ? count : 0}
        </span>
      )}
    </div>
  );
};
